import { t, Trans } from '@lingui/macro'
import { Box, FormLabel } from '@mui/material'
import { searchForAccountByFlow } from 'app/services/sfAuth/sfData/sfAccount'
import { getJoinRequestCountByFlow } from 'app/services/sfAuth/sfData/sfJoinRequest'
import { useFormikContext } from 'formik'
import { useSnackbar } from 'notistack'
import { FC, useState } from 'react'
import { myI18n } from 'translation/I18nConnectedProvider'
import { TextFieldWithFormik } from '../common-components/with-formik/TextFieldWithFormik'
import { errorsToTranslation } from '../grants/organization/JoinOrganization'
import { ResourcesDetailsButton, ResourcesDetailsLightButton } from '../resources/ResourcesDetailsCard/Button'
import { FirstLoginFlowFormikProps } from './index'
import { InfoBanner } from './InfoBanner'

interface OrganizationConnectSearchProps {
  displayBackBtn?: boolean
}

export const OrganizationConnectSearch: FC<OrganizationConnectSearchProps> = ({ displayBackBtn }) => {
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)

  const {
    values, handleChange, handleBlur, setFieldValue, validateForm, setFieldError
  } = useFormikContext<FirstLoginFlowFormikProps>()

  const onClickSearch = async () => {
    const errors = await validateForm()
    if (errors.search) {
      return
    }
    setLoading(true)
    Promise.all([
      searchForAccountByFlow({
        name: values.search
      }),
      getJoinRequestCountByFlow()
    ])
      .then(([result, joinRequests]) => {
        const joinOrganizationIds = joinRequests?.requests?.map(
          item => item.AccountId__c
        )
        if (typeof result === 'string') {
          if (!errorsToTranslation[result]) {
            enqueueSnackbar(result, { variant: 'error' })
          }
          setFieldValue('results', null)
          setFieldValue('joinOrganizationIds', null)
          setFieldValue('resultsError', result)
          setLoading(false)
        } else {
          setLoading(false)
          setFieldValue('results', result)
          setFieldValue('joinOrganizationIds', joinOrganizationIds)
        }
      })
      .catch(error => {
        console.log('searched error', { error })
        enqueueSnackbar(
          <Trans>
            JOIN_ORGANIZATION_POSSIBLE_TOO_MANY_RESULTS_ERROR
          </Trans>,
          { variant: 'error' }
        )
        setLoading(false)
      })
  }

  return (
    <>
      <FormLabel sx={{ textAlign: 'center', fontSize: '24px', lineHeight: '28px', mb: '54px', mt: '-32px' }}>
        <Trans>FIRST_LOGIN_FLOW_CONNECT_TO_ORGANIZATION_LABEL</Trans>
      </FormLabel>

      <FormLabel sx={{ mb: '14px' }}>
        <Trans>FIRST_LOGIN_FLOW_FIND_YOUR_ORGANIZATION_LABEL</Trans>
      </FormLabel>

      <InfoBanner
        description={<Trans>FIRST_LOGIN_FLOW_CONNECT_TO_ORGANIZATION_INFO_BANNER_DESCRIPTION</Trans>}
      />

      <TextFieldWithFormik
        isTopLabel
        name='search'
        placeholder={myI18n._(t`FIRST_LOGIN_FLOW_START_TYPING_ORGANIZATION_PLACEHOLDER`)}
        value={values.search}
        onChange={handleChange}
        onBlur={handleBlur}
        required
      />

      <Box sx={{ display: 'flex', gap: '16px', mt: '16px' }}>
        <ResourcesDetailsButton
          disabled={values.search === '' || loading}
          text={<Trans>FIRST_LOGIN_FLOW_SEARCH_BUTTON</Trans>}
          onClick={onClickSearch}
          sx={{ width: '100%' }}
        />
        {values.goal && displayBackBtn && <ResourcesDetailsLightButton
          disabled={loading}
          text={<Trans>FIRST_LOGIN_FLOW_BACK_BUTTON</Trans>}
          onClick={() => {
            setFieldValue('displayOrganizationConnectDialog', false)
          }}
                                          />}
      </Box>
    </>
  )
}
